var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeechBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512.056 512.056",
    height: 512,
    viewBox: "0 0 512.056 512.056",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.996 512.032c-2.577 0-5.175-.498-7.65-1.523-7.473-3.096-12.346-10.389-12.346-18.478l.011-233.584c-1.581-228.703 276.733-344.983 437.968-182.89 159.524 161.86 44.351 436.676-183.166 436.475-40.301.001-78.774-9.038-114.349-26.866-33.993-17.036-75.148-10.166-102.41 17.096l-3.912 3.912c-3.826 3.826-8.942 5.858-14.146 5.858zm81.271-76.149c19.422 0 38.961 4.422 57.119 13.522 30.016 15.045 62.55 22.659 96.653 22.627 191.182.281 289.155-233.255 154.517-368.33-136.569-136.67-370.536-38.779-369.546 154.456 0 .064.001.129.001.193l-.009 193.068c18.952-10.248 40.036-15.536 61.265-15.536zm94.733-179.851c0 13.807-11.193 25-25 25-33.162-1.317-33.153-48.688 0-50 13.807 0 25 11.193 25 25zm61-25c-13.807 0-25 11.193-25 25 1.317 33.162 48.688 33.153 50 0 0-13.807-11.193-25-25-25zm86 0c-13.807 0-25 11.193-25 25 1.317 33.162 48.688 33.153 50 0 0-13.807-11.193-25-25-25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble);
export default __webpack_public_path__ + "static/media/speech-bubble.0b9db525b94e5375e3dff4cc81038cfc.svg";
export { ForwardRef as ReactComponent };